import React from "react";

export type CheckIconProps = {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
  ariaLabel?: string;
  style?: React.CSSProperties;
  className?: string;
};

/**
 * Reusable Check Icon (20x21 viewBox). Default stroke #0F55A7, width/height 20.
 * Matches the inline SVG previously used in PaymentContent100DayABCPlan.
 */
const CheckIcon: React.FC<CheckIconProps> = ({
  width = 20,
  height = 20,
  stroke = "#0F55A7",
  strokeWidth = 2,
  ariaLabel,
  style,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel}
      role={ariaLabel ? "img" : undefined}
      className={className}
      style={{ flexShrink: 0, ...style }}
    >
      <path
        d="M5 9.5385L8.52941 14.6667L15 6.33337"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckIcon;
